import { VCheckbox, VTextField } from 'vuetify/lib'
import EnumValueSelectField from '@/components/ui/crud/fields/EnumValueSelectField.vue'
import VatRate from '@/models/enums/billing/VatRate'

const digits = (...lengths) => (v) =>
  (!!v && /^\d+$/.test(v) && lengths.includes(String(v).length)) ||
  `Только цифры (${lengths.join(' или ')})`

const optionalDigits = (length) => (v) =>
  !v || (/^\d+$/.test(v) && String(v).length === length) || `Только цифры (${length})`

// Общий конфиг полей для страниц создания и редактирования юрлица FAKT
export function faktLegalEntityFields ({ isCreate }) {
  return [
    { key: 'name', label: 'Название (полное)', component: VTextField, defaultValue: null, rules: ['required'] },
    { key: 'shortName', label: 'Сокращённое имя (например, ООО «ФАКТ»)', component: VTextField, defaultValue: null, rules: ['required'] },
    { key: 'inn', label: 'ИНН', component: VTextField, defaultValue: null, rules: ['required', digits(10, 12)] },
    { key: 'kpp', label: 'КПП', component: VTextField, defaultValue: null, rules: [optionalDigits(9)] },
    { key: 'ogrn', label: 'ОГРН', component: VTextField, defaultValue: null, rules: ['required', digits(13, 15)] },
    { key: 'legalAddress', label: 'Юридический адрес', component: VTextField, defaultValue: null, rules: ['required'] },
    { key: 'bankAccount', label: 'Расчётный счёт', component: VTextField, defaultValue: null, rules: ['required', digits(20)] },
    { key: 'corrAccount', label: 'Корреспондентский счёт', component: VTextField, defaultValue: null, rules: ['required', digits(20)] },
    { key: 'bik', label: 'БИК', component: VTextField, defaultValue: null, rules: ['required', digits(9)] },
    { key: 'bankName', label: 'Банк', component: VTextField, defaultValue: null, rules: ['required'] },
    { key: 'generalDirector', label: 'Генеральный директор', component: VTextField, defaultValue: null, rules: ['required'] },
    { key: 'isDefault', label: 'По-умолчанию', component: VCheckbox, defaultValue: false },
    { key: 'yookassaShopId', label: 'ЮKassa shop_id', component: VTextField, defaultValue: null, rules: ['required'] },
    {
      key: 'vatRate',
      label: 'Ставка НДС в чеке',
      component: EnumValueSelectField,
      enumClass: VatRate,
      defaultValue: VatRate.None,
      rules: ['required'],
    },
    // При создании ключ обязателен; при редактировании поле рендерят слоты страницы
    // (пустое значение = не менять ключ), плюс отдельная строка с маской текущего ключа
    ...(isCreate
      ? [{ key: 'yookassaSecretKey', label: 'ЮKassa секретный ключ', component: VTextField, defaultValue: null, rules: ['required'] }]
      : [{ key: 'secretKeyLast4' }, { key: 'yookassaSecretKey' }]),
  ]
}
